<template>
  <div>
    <header-wrapper/>
    <div class="body-wrapper">
      <b-container class="full-sm">
        <router-view/>
      </b-container>
    </div>
    <footer-wrapper/>
  </div>
</template>

<style lang="scss">
  @import "~bootstrap/scss/mixins";

  /**

  1. Desktop
    1.1 loading
    1.2 ibox
    1.3 table-beauty
  2. Mobile

  **/

  // 1.1 loading

  .loading-spinner {
    overflow: hidden;
    position: relative;
    padding: 0;
    .spin,
    .spin:after {
      border-radius: 50%;
      width: 5em;
      height: 5em;
    }
    .spin {
      margin: 20px auto;
      font-size: 10px;
      position: relative;
      text-indent: -9999em;
      border: .3em solid $white;
      // border-top: 1.1em solid rgba(255, 255, 255, 0.2);
      // border-right: 1.1em solid rgba(255, 255, 255, 0.2);
      // border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
      border-left: .3em solid $dark;
      transform: translateZ(0);
      animation: spin 0.4s infinite linear;
    }

  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  // 1.2 ibox

  .ibox {
    position: relative;
    margin-bottom: 20px;
    width: 100%;
    box-shadow: 0 1px 1px rgba(0,0,0,0.1);

    &.full {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 100%;
      overflow-x: hidden;
      overflow-y: auto;
      z-index: 2;

      .ibox-content {
        padding: 1rem;
      }
    }

    .table-beauty {
      table {
        &:not(.has-paging){
          margin: 0;
          border: 0;
        }

        &.has-paging {
          margin-bottom: 0;
        }
      }

      .table-beauty-bottom {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
      }
    }

    &:not(.full) {
      .table-beauty table.table-bordered {
        &.has-paging {
          border-left: 0;
          border-right: 0;
          border-top: 0;
        }

        th {
          border-top: 0;
        }

        th:first-child,
        td:first-child {
          border-left: 0;
        }

        th:last-child,
        td:last-child {
          border-right: 0;
        }

        /*tr:last-child td {*/
        /*  border-bottom: 0;*/
        /*}*/
      }

      .table-beauty-bottom {
        padding-left: 0.7rem;
        padding-right: 0.7rem;
      }
    }
  }

  .ibox-title {
    display: flex !important;
    background: $dark;
    color: $light;
    padding: .5rem 1rem;
    min-height: 2.7rem;
  }

  .ibox-title span {
    display: block;
    font-weight: 300;
    font-size: 1.2rem;
    min-height: 1.5rem;
    text-overflow: ellipsis;
    flex-grow: 1 !important;
  }

  .ibox-tools {
    margin: -0.1rem;
    margin-right: 0;
    height: 1.9rem;

    .btn:focus,.btn:active {
      outline: none !important;
      box-shadow: none;
    }
  }

  .ibox-content {
    background-color: #fff;
  }

  // 1.3 table-beauty

  .table-beauty, .table-beauty .beauty-scoped {
    position: relative;
  }

  .table-beauty .table-responsive > .table-bordered {
    border: auto;
  }

  .table-beauty table {
    clear: both;
    max-width: none!important;
    border-spacing: 0;

    th, td {
      box-sizing: content-box;
    }
  }

  // Only fix image potition in phone, soalnya begitu nampak
  @include media-breakpoint-down(sm) {
    .table-beauty {
      overflow: hidden;
    }

    .table-beauty table {
      font-size: 0.9rem;
    }
    .table-beauty table td {
      font-size: inherit;
      padding: 0.5rem;
    }

    .container.full-sm {
      padding-right: 0;
      padding-left: 0;

      .row {
        margin-right: 0;
        margin-left: 0;

        & > [class^="col-"],
        & > [class*=" col-"] {
          padding-right: 0;
          padding-left: 0;
        }

      }

    }
  }

  .table-beauty table thead th.sorting {
    padding-right: 30px;

    a {
      display: none;
    }

    a, a:hover, a:focus {
      text-align: right;
      text-decoration: none;
      color: inherit;
      outline: none;
    }

    a.sorting,
    a.sorting_asc,
    a.sorting_asc_disabled,
    a.sorting_desc,
    a.sorting_desc_disabled {
      position: absolute;
      display: block;
      right: 0;
      bottom: 0;
    }

    a.sorting:before,
    a.sorting_asc:before,
    a.sorting_asc_disabled:before,
    a.sorting_desc:before,
    a.sorting_desc_disabled:before {
      content: "\2191";
      right: 1em;
    }

    a.sorting:after,
    a.sorting_asc:after,
    a.sorting_asc_disabled:after,
    a.sorting_desc:after,
    a.sorting_desc_disabled:after {
      content: "\2193";
      right: .5em;
    }

    a.sorting:after,
    a.sorting:before,
    a.sorting_asc:after,
    a.sorting_asc:before,
    a.sorting_asc_disabled:after,
    a.sorting_asc_disabled:before,
    a.sorting_desc:after,
    a.sorting_desc:before,
    a.sorting_desc_disabled:after,
    a.sorting_desc_disabled:before {
      position: absolute;
      display: block;
      opacity: .3;
      bottom: .9rem;
    }

    a.sorting_asc:before,
    a.sorting_desc:after {
      opacity: 1;
    }

    a.sorting,
    a.sorting_asc,
    a.sorting_desc {
      cursor: pointer;
    }

    /*a.sorting:hover:before,*/
    /*a.sorting_desc:hover:before,*/
    /*a.sorting_asc:hover:after {*/
    /*  opacity: 1;*/
    /*}*/

    /*a.sorting_asc:hover:before,*/
    /*a.sorting_desc:hover:after {*/
    /*  opacity: .2;*/
    /*}*/
  }

  .table-beauty table thead > tr > td.sorting,
  .table-beauty table thead > tr > th.sorting {
    position: relative;
  }

  .table-beauty table td.no-hover:hover {
    background: $white;
  }

  .table-beauty .table-beaury-loading {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0,.125);
    text-align: center;
    border-radius: 0;
    width: auto;
    border: none;
  }

  .table-beauty {
    .table-beauty-info {
      padding-top: .5em;
      white-space: nowrap;
    }

    .table-beauty-paginate {
      margin: 2px 0;
      white-space: nowrap;
      justify-content: flex-end;

      ul.pagination {
        margin: 2px 0;
        white-space: nowrap;
        justify-content: flex-end;
      }
    }
  }

  // .table-beauty table {
  //   margin: 0;
  //   border-top: 0;

  //   th {
  //     // border-top: 0;
  //   }

  //   th:first-child,
  //   td:first-child, {
  //     // border-left: .1rem solid $dark;
  //   }

  //   th:last-child,
  //   td:last-child, {
  //     // border-right: .1rem solid $dark;
  //   }

  //   tr:last-child td {
  //     // border-bottom: .1rem solid $dark;
  //   }


  // }
</style>

<script>
  import 'flag-icon-css/css/flag-icon.css'
  import headerWrapper from '@/components/header.vue'
  import footerWrapper from '@/components/footer.vue'

  export default {
    components: {
      headerWrapper,
      footerWrapper
    },
    sockets: {
      user_change() {
        this.$store.dispatch( 'authentication/logout', 'User data has changed by administrator' )
          .then( () => {
            this.$router.push( '/login' )

            if (typeof this.$socket !== 'undefined') {
              this.$socket.disconnect();
            }
          } )
      },
      user_delete() {
        this.$store.dispatch( 'authentication/logout', 'User has deleted by administrator' )
          .then( () => {
            this.$router.push( '/login' )

            if (typeof this.$socket !== 'undefined') {
              this.$socket.disconnect();
            }
          } )
      }
    }
    // mounted() {
    //   /sound/circus-clown-horn.mp3
    //   window.audioPlay = number => {
    //     const audioElement = document.createElement('audio'),
    //       audioFiles = [
    //         '/sound/circus-clown-horn-sound.mp3',
    //         '/sound/mberok1.ogg'];
    //     audioElement.setAttribute('volume', '1.0');
    //     if (audioFiles[number]) {
    //       audioElement.setAttribute('src', audioFiles[number]);
    //       audioElement.play();
    //       console.log('playing ' + audioFiles[number]);
    //       return audioElement;
    //     }
    //     return false;
    //   }
    // }
  };
</script>